import React from "react";
import { observer } from "mobx-react-lite";
import CertificationDashboard from "./CertificationDashboard";

const DGNB18Dashboard = () => {
  const reportID = "74e5b8d0-4de1-11f0-8b69-2bc84a6af72d";
  return <CertificationDashboard reportID={reportID} />;
};

export default observer(DGNB18Dashboard);
